<nav class="navbar navbar-expand-lg fixed-top">
  <div class="container-fluid">
    <div class="navbar-brand">
      <img src="/assets/rettxlogo-white.png" class="logo me-2" [alt]="copy.logoAlt">
    </div>
  </div>
</nav>
<div class="error-page">
  <main class="container">
    <h1>{{ copy.heading }}</h1>
    <p>{{ copy.cause[cause] }}</p>
    <img src="assets/images/unicorn.jpg" [alt]="copy.imageAlt" class="error-image" />
    <section class="incident" aria-labelledby="incident-title">
      <h2 id="incident-title">{{ copy.incidentHeading }}</h2>
      <code>{{ incidentCode }}</code>
      <button type="button" class="copy-action" (click)="copyIncidentCode()">
        {{ copy.copyCode }}
      </button>
      <p>{{ copy.incidentHelp }}</p>
    </section>
    <div class="recovery-actions" [attr.aria-label]="copy.recoveryOptionsLabel">
      <button
        type="button"
        class="recovery-action recovery-action-primary"
        (click)="recover('primary')">
        {{ primaryRecovery.label }}
      </button>
      <button
        type="button"
        class="recovery-action recovery-action-secondary"
        (click)="recover('fallback')">
        {{ fallbackRecovery.label }}
      </button>
    </div>
    @if (recoveryMessage) {
      <p class="recovery-message" role="status" aria-live="polite">
        {{ recoveryMessage }}
      </p>
    }
  </main>
</div>